import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { authApi } from '../api';

export default function ProfilePage() {
  const { user } = useAuth();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (newPassword.length < 6) {
      setError('Новый пароль должен содержать минимум 6 символов');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Новые пароли не совпадают');
      return;
    }

    setLoading(true);
    try {
      await authApi.changePassword(oldPassword, newPassword);
      setSuccess('Пароль успешно изменён');
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (e: any) {
      setError(e.response?.data?.error || 'Ошибка изменения пароля');
    } finally {
      setLoading(false);
    }
  };

  const roleLabels: Record<string, string> = {
    ADMIN: 'Администратор',
    MANAGER: 'Менеджер',
    VIEWER: 'Наблюдатель',
  };

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">Профиль</h2>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, maxWidth: 800 }}>
        <div className="card">
          <div className="card-header">
            <h3 style={{ fontSize: 16, fontWeight: 600 }}>Информация</h3>
          </div>
          <div className="card-body">
            <div className="form-group">
              <label className="form-label">Имя</label>
              <div style={{ padding: '8px 0', fontSize: 14 }}>{user?.firstName}</div>
            </div>
            <div className="form-group">
              <label className="form-label">Фамилия</label>
              <div style={{ padding: '8px 0', fontSize: 14 }}>{user?.lastName}</div>
            </div>
            <div className="form-group">
              <label className="form-label">Email</label>
              <div style={{ padding: '8px 0', fontSize: 14 }}>{user?.email}</div>
            </div>
            <div className="form-group">
              <label className="form-label">Роль</label>
              <div style={{ padding: '8px 0', fontSize: 14 }}>{roleLabels[user?.role] || user?.role}</div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h3 style={{ fontSize: 16, fontWeight: 600 }}>Изменить пароль</h3>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              {error && (
                <div style={{ padding: '10px 14px', marginBottom: 16, background: 'var(--color-danger-bg, #fee)', color: 'var(--color-danger, #c00)', borderRadius: 6, fontSize: 13 }}>
                  {error}
                </div>
              )}
              {success && (
                <div style={{ padding: '10px 14px', marginBottom: 16, background: 'var(--color-success-bg, #efe)', color: 'var(--color-success, #060)', borderRadius: 6, fontSize: 13 }}>
                  {success}
                </div>
              )}
              <div className="form-group">
                <label className="form-label">Текущий пароль *</label>
                <input className="form-input" type="password" value={oldPassword} onChange={e => setOldPassword(e.target.value)} required />
              </div>
              <div className="form-group">
                <label className="form-label">Новый пароль *</label>
                <input className="form-input" type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required minLength={6} />
              </div>
              <div className="form-group">
                <label className="form-label">Подтвердите новый пароль *</label>
                <input className="form-input" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required minLength={6} />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Сохранение...' : 'Изменить пароль'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
